import React, { useEffect, useState, useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import './LandingPageContent.css';
import classNames from 'classnames';
import ApiSender from './common/ApiLogic.js';
import { v4 as uuidv4 } from 'uuid';

function LandingPageFlow() {

  const location = useLocation();
  const [keyword, setKeyword] = useState(null);
  const [selectedPlan, setSelectedPlan] = useState('Daily');
  const [isGradient, setIsGradient] = useState(false);
  const [bundlePlans, setBundlePlans] = useState([]);
  const [language, setLanguage] = useState('ID');
  const [goalId, setGoalId] = useState(null);
  const [goalName, setGoalName] = useState(null);
  const params = useMemo(() => new URLSearchParams(location.search), [location.search]);
  const paramsObject = {};
  for (const [key, value] of params.entries()) {
    paramsObject[key] = value;
  }

  useEffect(() => {
    if (paramsObject && 'campaignId' in paramsObject) {
      const fetchData = async () => {
        try {
          const response = await fetch(process.env.REACT_APP_GOOGLE_BASE_URL + 'campaign/info?uuid=' + paramsObject.campaignId,
            { method: 'GET', headers: { "Content-Type": "application/json" } });
          if (response.ok) {
            const data = await response.json();
            const status = data.status;
            if (status) {
              setGoalId(data.goalId);
              setGoalName(data.goalName);
            }
          }
        }
        catch (error) {
        }
      }
      fetchData();
    }
  }, [paramsObject]);

  useEffect(() => {
    saveGoogleHistory();
  }, []);

  const saveGoogleHistory = async () => {
    const apiSender = new ApiSender();
    await apiSender.saveGoogleHistory(window.location.origin + location.pathname, paramsObject);
  }

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(process.env.REACT_APP_BASE_URL + '/disclaimer');
        const data = await response.json();
        if (response.ok && data.message === 'Success') {
          const filteredPlans = data.serviceDisclaimers.filter(plan => plan.language === language);
          const defaultPlan = filteredPlans.find(plan => plan.defaultPlan);
          if (defaultPlan) {
            setSelectedPlan(defaultPlan.plan);
            setKeyword(defaultPlan.keyword);
          }
          setBundlePlans(filteredPlans);
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchData();
  }, [language]);

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const lang = searchParams.get('lang');
    if (!lang || (lang.toUpperCase() !== 'EN' && lang.toUpperCase() !== 'ID')) {
      return;
    }
    setLanguage(lang.toUpperCase());
    setIsGradient(lang.toUpperCase() === 'ID' ? true : false);
  }, [location.search]);

  const handleLanguage = (event) => {
    const selectedLang = event.target.textContent.trim();
    setLanguage(selectedLang);
    setIsGradient(selectedLang === 'ID' ? true : false);
  };

  const handleSelectPlan = (title, keyword) => {
    setSelectedPlan(title);
    setKeyword(keyword);
  };

  const gradientStyle = {
    background: isGradient
      ? 'linear-gradient(to left, #AA4098 50%, #D86F71 50%)'
      : 'linear-gradient(to right, #AA4098 50%, #D86F71 50%)',
  };

  async function saveHistory() {
    const generatedUuid = uuidv4();
    const timestamp = Date.now();
    const clickId = generatedUuid + "-" + timestamp;

    const apiSender = new ApiSender();
    const result = await apiSender.saveHistory('/subscribe', null, clickId, language, goalId, goalName, window.location.origin + location.pathname, "ID MAIN LP", paramsObject);
    if (result.success) {
      const plan = selectedPlan === 'Daily' ? 'ks1' : (selectedPlan === 'Weekly' ? 'ks2' : 'ks3');
      let paramsString = "";
      for (let [key, value] of params.entries()) {
        paramsString += `${key}=${value}&`;
      }
      paramsString = paramsString.slice(0, -1);
      let url = "http://202.43.164.82:8099/wapoption/" + plan;
      if (paramsString !== '') {
        url = url + "?" + paramsString + "&clickId=" + clickId;
      }
      else {
        url = url + "?clickId=" + clickId;
      }
      window.location.href = url;
    }
  }

  return (

    <div className="App">

      <div className="upside" >
        <div className="header">
          <div className="logo">
            <img alt='' src='%PUBLIC_URL%/../../kid-english.png' />
          </div>
          <div className="language" style={gradientStyle} onClick={handleLanguage}>
            <p>ID</p>
            <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 24 24" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path fill="none" strokeWidth="2" d="M12,23 C18.0751322,23 23,18.0751322 23,12 C23,5.92486775 18.0751322,1 12,1 C5.92486775,1 1,5.92486775 1,12 C1,18.0751322 5.92486775,23 12,23 Z M12,23 C15,23 16,18 16,12 C16,6 15,1 12,1 C9,1 8,6 8,12 C8,18 9,23 12,23 Z M2,16 L22,16 M2,8 L22,8"></path></svg>
            <p>EN</p>
          </div>
        </div>

        <div className="title">
          <div className="photo">
            <img alt='img' src='%PUBLIC_URL%/../../kid-security.png' />
          </div>
        </div>
      </div>

      <div className="content">
        <div className="input">
          <div className="pricing-container">
            {bundlePlans.map(p => (
              <div key={p.plan} className={classNames('pricing-box', { 'selected': selectedPlan === p.plan })} onClick={() => handleSelectPlan(p.plan, p.keyword)}>
                <span>{p.plan}</span>
                <span style={{ display: 'inline' }}>ID {p.price}</span>
              </div>
            ))}
          </div>

          {
            language === 'ID' ? (<button id="pin" onClick={saveHistory}>Berlangganan</button>) : (<button id="pin" onClick={saveHistory}>Subscribe</button>)
          }
        </div>
        <div className="terms" style={{ direction: "ltr" }}>
          {bundlePlans.map(plan => (
            (plan.language === language && plan.plan === selectedPlan) && (
              <p key={plan.id}>{plan.disclaimer}</p>
            )
          ))}
        </div>
      </div>

    </div>

  );
}

export default LandingPageFlow;